const PARAMETER_TYPES = {
    is_duplicate: 'is_duplicate',
}

const PARAMETER_DUPLICATE_VALUES = {
    yes: {
        id: 'Yes',
        name: 'Yes',
    },
    no: {
        id: 'No',
        name: 'No',
    },
}

export {
    PARAMETER_TYPES,
    PARAMETER_DUPLICATE_VALUES,
}
